module.exports = __webpack_public_path__ + "img/cow.db89de0e.svg";